import { useParams } from 'react-router-dom'
import { GrowlMessage } from '@campgladiator/cgui-core.molecules.growl-message'
import { PageTitleWithSearchInputAndNewButton } from 'components/module/shared/page-title-search-input-new-button'
import { CommunicationPreferencesPanel } from './components/communication-preferences-panel'
import useWithCommunicationPreferences from './use-with-communication-preferences'

const Communications = () => {
  const { id } = useParams<{ id: string }>()

  const {
    error,
    successMessage,
    clearErrors,
    handleSave,
    isSaving,
    ...panelProps
  } = useWithCommunicationPreferences({
    userId: id,
  })

  const pageTitleProps = {
    title: 'Communication Preferences',
    placeholder: '',
    newButtonText: isSaving ? 'Saving...' : 'Save Changes',
    showSearchInput: false,
    onSearch: () => {},
    onNewButtonClick: handleSave,
  }

  return (
    <>
      <GrowlMessage
        isVisible={!!error || !!successMessage}
        onClick={clearErrors}
      >
        {error || successMessage}
      </GrowlMessage>

      <PageTitleWithSearchInputAndNewButton {...pageTitleProps} />

      <CommunicationPreferencesPanel isSaving={isSaving} {...panelProps} />
    </>
  )
}

export default Communications
